import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
var _pillEventsTheme_filter, _pillEventsTheme_filter1, _pillEventsTheme_filter2, _checkboxEventsTheme_primary, _checkboxEventsTheme_primary1, _checkboxEventsTheme_primary2, _pillEventsTheme_filter3, _pillEventsTheme_filter4, _checkboxEventsTheme_primary3, _checkboxEventsTheme_primary4, _checkboxEventsTheme_primary5;
import { Core } from "@faire/design-tokens";
import { Snowflake } from "@faire/web--source/slate/icons/faire-markets/Snowflake";
import { PromotionalEventType } from "@faire/web-api--source/indigofair/common/PromotionalEventType";
import { buttonEventsTheme, primaryDestructiveStyle, secondaryDestructiveStyle, tertiaryDestructiveStyle } from "../Button/theme";
import { extendBaseThemeVariant } from "../Button/utils";
import { pillEventsTheme } from "../Filter/theme";
import { FaireFashionWeek } from "../icons/FaireFashionWeek";
import { bannerEventsTheme } from "./Banners";
import { checkboxEventsTheme } from "./Checkbox";
import { DefaultTheme } from "./DefaultTheme";
import { eventsThemeColors, getEventTheme } from "./eventsThemeColors";
import { EventsThemeShape } from "./EventsThemeShape";
export var EventsTheme = _object_spread_props(_object_spread({}, DefaultTheme), {
    name: "EventsTheme",
    eventIcon: {
        Component: Snowflake,
        color: getEventTheme("faireMarket").badgeIcon,
        backgroundColor: getEventTheme("faireMarket").badgeBackground
    },
    buttons2: buttonEventsTheme,
    pills: pillEventsTheme,
    banners: bannerEventsTheme,
    checkboxes: checkboxEventsTheme
});
var _getEventTheme_promoTextInverse, _getEventTheme_promoTextInverse1, _pillEventsTheme_filter_secondary, _pillEventsTheme_filter_label, _checkboxEventsTheme_primary_icon;
export var FaireMarketTheme = _object_spread_props(_object_spread({}, EventsTheme), {
    name: "FaireMarketTheme",
    eventsThemeColors: getEventTheme("faireMarket"),
    eventIcon: {
        Component: EventsThemeShape.faireMarket.badge,
        color: getEventTheme("faireMarket").badgeIcon,
        backgroundColor: getEventTheme("faireMarket").badgeBackground
    },
    buttons2: _object_spread_props(_object_spread({}, buttonEventsTheme), {
        primary: _object_spread({}, buttonEventsTheme.primary),
        secondary: _object_spread({}, buttonEventsTheme.secondary),
        tertiary: _object_spread_props(_object_spread({}, buttonEventsTheme.tertiary), {
            base: extendBaseThemeVariant(buttonEventsTheme.tertiary.base, function(param) {
                var $destructive = param.$destructive;
                return _object_spread({
                    "text-decoration-color": getEventTheme("faireMarket").promoText,
                    color: getEventTheme("faireMarket").promoText
                }, $destructive ? tertiaryDestructiveStyle.base : {});
            }),
            hover: extendBaseThemeVariant(buttonEventsTheme.tertiary.hover, function(param) {
                var $destructive = param.$destructive;
                return _object_spread({
                    "text-decoration-color": getEventTheme("faireMarket").promoText,
                    color: getEventTheme("faireMarket").promoText
                }, $destructive ? tertiaryDestructiveStyle.hover : {});
            }),
            active: extendBaseThemeVariant(buttonEventsTheme.tertiary.active, function(param) {
                var $destructive = param.$destructive;
                return _object_spread({
                    "text-decoration-color": getEventTheme("faireMarket").promoText,
                    color: getEventTheme("faireMarket").promoText
                }, $destructive ? tertiaryDestructiveStyle.active : {});
            })
        })
    }),
    pills: _object_spread_props(_object_spread({}, pillEventsTheme), {
        filter: _object_spread_props(_object_spread({}, pillEventsTheme.filter), {
            primary: _object_spread_props(_object_spread({}, (_pillEventsTheme_filter = pillEventsTheme.filter) === null || _pillEventsTheme_filter === void 0 ? void 0 : _pillEventsTheme_filter.primary), {
                color: getEventTheme("faireMarket").primaryDark,
                hover: getEventTheme("faireMarket").primaryDark,
                contrast: (_getEventTheme_promoTextInverse = getEventTheme("faireMarket").promoTextInverse) !== null && _getEventTheme_promoTextInverse !== void 0 ? _getEventTheme_promoTextInverse : getEventTheme("faireMarket").promoText
            }),
            secondary: (_pillEventsTheme_filter_secondary = (_pillEventsTheme_filter1 = pillEventsTheme.filter) === null || _pillEventsTheme_filter1 === void 0 ? void 0 : _pillEventsTheme_filter1.secondary) !== null && _pillEventsTheme_filter_secondary !== void 0 ? _pillEventsTheme_filter_secondary : {
                color: Core.surface.subdued,
                hover: Core.border.muted,
                contrast: (_getEventTheme_promoTextInverse1 = getEventTheme("faireMarket").promoTextInverse) !== null && _getEventTheme_promoTextInverse1 !== void 0 ? _getEventTheme_promoTextInverse1 : getEventTheme("faireMarket").promoText
            },
            label: (_pillEventsTheme_filter_label = (_pillEventsTheme_filter2 = pillEventsTheme.filter) === null || _pillEventsTheme_filter2 === void 0 ? void 0 : _pillEventsTheme_filter2.label) !== null && _pillEventsTheme_filter_label !== void 0 ? _pillEventsTheme_filter_label : {
                p: true
            }
        })
    }),
    banners: _object_spread_props(_object_spread({}, bannerEventsTheme), {
        alert: _object_spread_props(_object_spread({}, bannerEventsTheme.alert), {
            color: getEventTheme("faireMarket").lightBackground,
            textColor: getEventTheme("faireMarket").promoText
        })
    }),
    checkboxes: _object_spread_props(_object_spread({}, EventsTheme.checkboxes), {
        primary: _object_spread_props(_object_spread({}, checkboxEventsTheme.primary), {
            fill: getEventTheme("faireMarket").primaryDark,
            icon: (_checkboxEventsTheme_primary_icon = (_checkboxEventsTheme_primary = checkboxEventsTheme.primary) === null || _checkboxEventsTheme_primary === void 0 ? void 0 : _checkboxEventsTheme_primary.icon) !== null && _checkboxEventsTheme_primary_icon !== void 0 ? _checkboxEventsTheme_primary_icon : Core.surface.inverse,
            border: getEventTheme("faireMarket").primaryDark,
            checked: _object_spread_props(_object_spread({}, (_checkboxEventsTheme_primary1 = checkboxEventsTheme.primary) === null || _checkboxEventsTheme_primary1 === void 0 ? void 0 : _checkboxEventsTheme_primary1.checked), {
                color: getEventTheme("faireMarket").primaryDark
            }),
            hover: _object_spread_props(_object_spread({}, (_checkboxEventsTheme_primary2 = checkboxEventsTheme.primary) === null || _checkboxEventsTheme_primary2 === void 0 ? void 0 : _checkboxEventsTheme_primary2.hover), {
                color: getEventTheme("faireMarket").primaryDark
            })
        })
    }),
    toggle: _object_spread_props(_object_spread({}, EventsTheme.toggle), {
        active: _object_spread_props(_object_spread({}, EventsTheme.toggle.active), {
            on: _object_spread_props(_object_spread({}, EventsTheme.toggle.active.on), {
                toggle: _object_spread_props(_object_spread({}, EventsTheme.toggle.active.on.toggle), {
                    container: _object_spread_props(_object_spread({}, EventsTheme.toggle.active.on.toggle.container), {
                        surface: getEventTheme("faireMarket").primaryDark,
                        border: getEventTheme("faireMarket").primaryDark
                    }),
                    indicator: _object_spread_props(_object_spread({}, EventsTheme.toggle.active.on.toggle.indicator), {
                        surface: getEventTheme("faireMarket").promoText
                    })
                })
            }),
            off: _object_spread_props(_object_spread({}, EventsTheme.toggle.active.off), {
                toggle: _object_spread_props(_object_spread({}, EventsTheme.toggle.active.off.toggle), {
                    container: _object_spread_props(_object_spread({}, EventsTheme.toggle.active.off.toggle.container), {
                        border: getEventTheme("faireMarket").primaryDark
                    }),
                    indicator: _object_spread_props(_object_spread({}, EventsTheme.toggle.active.off.toggle.indicator), {
                        surface: getEventTheme("faireMarket").primaryDark
                    })
                })
            })
        })
    })
});
var _pillEventsTheme_filter_secondary1, _pillEventsTheme_filter_label1, _checkboxEventsTheme_primary_icon1;
export var FaireFashionWeekTheme = _object_spread_props(_object_spread({}, EventsTheme), {
    name: "FaireFashionWeekTheme",
    eventsThemeColors: eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3],
    eventIcon: {
        Component: FaireFashionWeek,
        color: eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].badgeIcon,
        backgroundColor: eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].badgeBackground
    },
    buttons2: {
        primary: _object_spread_props(_object_spread({}, buttonEventsTheme.primary), {
            base: extendBaseThemeVariant(buttonEventsTheme.primary.base, function(param) {
                var $destructive = param.$destructive;
                return _object_spread({
                    border: "1px solid ".concat(eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark),
                    "background-color": eventsThemeColors.faireFashionWeek.primaryLight,
                    color: eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark
                }, $destructive ? primaryDestructiveStyle.base : {});
            }),
            hover: extendBaseThemeVariant(buttonEventsTheme.primary.hover, function(param) {
                var $destructive = param.$destructive;
                return _object_spread({
                    border: "1px solid ".concat(eventsThemeColors.faireFashionWeek.primaryLight),
                    "background-color": eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark,
                    color: eventsThemeColors.faireFashionWeek.primaryLight
                }, $destructive ? primaryDestructiveStyle.hover : {});
            }),
            active: extendBaseThemeVariant(buttonEventsTheme.primary.active, function(param) {
                var $destructive = param.$destructive;
                return _object_spread({
                    border: "1px solid ".concat(eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark),
                    "background-color": eventsThemeColors.faireFashionWeek.primaryLight,
                    color: eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark
                }, $destructive ? primaryDestructiveStyle.active : {});
            })
        }),
        secondary: _object_spread_props(_object_spread({}, buttonEventsTheme.secondary), {
            base: extendBaseThemeVariant(buttonEventsTheme.secondary.base, function(param) {
                var $destructive = param.$destructive;
                return _object_spread({
                    border: "1px solid ".concat(eventsThemeColors.faireFashionWeek.primaryLight),
                    "background-color": eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark,
                    color: eventsThemeColors.faireFashionWeek.primaryLight
                }, $destructive ? secondaryDestructiveStyle.base : {});
            }),
            hover: extendBaseThemeVariant(buttonEventsTheme.secondary.hover, function(param) {
                var $destructive = param.$destructive;
                return _object_spread({
                    border: "1px solid ".concat(eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark),
                    "background-color": eventsThemeColors.faireFashionWeek.primaryLight,
                    color: eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark
                }, $destructive ? secondaryDestructiveStyle.hover : {});
            }),
            active: extendBaseThemeVariant(buttonEventsTheme.secondary.active, function(param) {
                var $destructive = param.$destructive;
                return _object_spread({
                    border: "1px solid ".concat(eventsThemeColors.faireFashionWeek.primaryLight),
                    "background-color": eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark,
                    color: eventsThemeColors.faireFashionWeek.primaryLight
                }, $destructive ? secondaryDestructiveStyle.active : {});
            })
        }),
        tertiary: _object_spread_props(_object_spread({}, buttonEventsTheme.tertiary), {
            base: extendBaseThemeVariant(buttonEventsTheme.tertiary.base, function(param) {
                var $destructive = param.$destructive;
                return _object_spread({
                    "text-decoration-color": eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark,
                    color: eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark
                }, $destructive ? tertiaryDestructiveStyle.base : {});
            }),
            hover: extendBaseThemeVariant(buttonEventsTheme.tertiary.hover, function(param) {
                var $destructive = param.$destructive;
                return _object_spread({
                    color: eventsThemeColors.faireFashionWeek.primaryLight,
                    "text-decoration-color": eventsThemeColors.faireFashionWeek.primaryLight
                }, $destructive ? tertiaryDestructiveStyle.hover : {});
            }),
            active: extendBaseThemeVariant(buttonEventsTheme.tertiary.active, function(param) {
                var $destructive = param.$destructive;
                return _object_spread({
                    color: eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark,
                    "text-decoration-color": eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark
                }, $destructive ? tertiaryDestructiveStyle.active : {});
            })
        })
    },
    pills: _object_spread_props(_object_spread({}, pillEventsTheme), {
        filter: _object_spread_props(_object_spread({}, pillEventsTheme.filter), {
            primary: {
                color: eventsThemeColors.faireFashionWeek.primaryLight,
                hover: eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark,
                contrast: eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark
            },
            secondary: (_pillEventsTheme_filter_secondary1 = (_pillEventsTheme_filter3 = pillEventsTheme.filter) === null || _pillEventsTheme_filter3 === void 0 ? void 0 : _pillEventsTheme_filter3.secondary) !== null && _pillEventsTheme_filter_secondary1 !== void 0 ? _pillEventsTheme_filter_secondary1 : {
                color: Core.surface.subdued,
                hover: Core.border.muted,
                contrast: Core.surface.default
            },
            label: (_pillEventsTheme_filter_label1 = (_pillEventsTheme_filter4 = pillEventsTheme.filter) === null || _pillEventsTheme_filter4 === void 0 ? void 0 : _pillEventsTheme_filter4.label) !== null && _pillEventsTheme_filter_label1 !== void 0 ? _pillEventsTheme_filter_label1 : {
                p: true
            }
        })
    }),
    banners: _object_spread_props(_object_spread({}, bannerEventsTheme), {
        alert: _object_spread_props(_object_spread({}, bannerEventsTheme.alert), {
            color: eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].decorative1,
            textColor: eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].promoText
        })
    }),
    checkboxes: _object_spread_props(_object_spread({}, EventsTheme.checkboxes), {
        primary: _object_spread_props(_object_spread({}, checkboxEventsTheme.primary), {
            fill: eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark,
            icon: (_checkboxEventsTheme_primary_icon1 = (_checkboxEventsTheme_primary3 = checkboxEventsTheme.primary) === null || _checkboxEventsTheme_primary3 === void 0 ? void 0 : _checkboxEventsTheme_primary3.icon) !== null && _checkboxEventsTheme_primary_icon1 !== void 0 ? _checkboxEventsTheme_primary_icon1 : Core.surface.inverse,
            border: eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark,
            checked: _object_spread_props(_object_spread({}, (_checkboxEventsTheme_primary4 = checkboxEventsTheme.primary) === null || _checkboxEventsTheme_primary4 === void 0 ? void 0 : _checkboxEventsTheme_primary4.checked), {
                color: eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark
            }),
            hover: _object_spread_props(_object_spread({}, (_checkboxEventsTheme_primary5 = checkboxEventsTheme.primary) === null || _checkboxEventsTheme_primary5 === void 0 ? void 0 : _checkboxEventsTheme_primary5.hover), {
                color: eventsThemeColors[PromotionalEventType.FAIRE_FASHION_WEEK_V3].primaryDark
            })
        })
    })
});
